import React from "react";
import formatLargeNumber from "../../../utility/formatLargeNumber";
import "./Stats.css";
import { images } from "../../../assets";

function Stats({ totalStats }) {
  function renderNumberWithAmount(number) {
    const formattedNumber = formatLargeNumber(number);
    const [wholePart, decimalPart] = formattedNumber.split(".");
    return (
      <>
        <div className="number">
          <div>{wholePart}</div>
          {decimalPart && <div>{`.${decimalPart.split(" ")[0]}`}</div>}
          <div className="amount">
            {decimalPart
              ? formattedNumber.split(" ")[1] + "+"
              : formattedNumber.split(" ")[1]}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="stats">
      <div className="statsbox">
        {totalStats && (
          <>
            <div className="statscontent">
              {renderNumberWithAmount(totalStats.total_user_count)}
              <div className="purpose">Changemakers</div>
            </div>
            <div className="statscontent">
              {renderNumberWithAmount(totalStats.total_raised)}
              <div className="purpose">Charity raised</div>
            </div>
            <div className="statscontent">
              {renderNumberWithAmount(totalStats.total_distance)}
              <div className="purpose">steps taken</div>
            </div>
          </>
        )}
      </div>
      <div className="map">
        <img src={images.map} alt="map" />
      </div>
    </div>
  );
}

export default Stats;
